import firebase from 'firebase/app'
import 'firebase/storage'
import User from 'utils/User'

// const config = require('../../../config-env.json')
const ENV = process.env.API_ENV

const user = new User()

if (user) {
  let env = ''
  if (ENV === 'production') {
    env = 'melrin-prd'
  } else if (ENV === 'homologation') {
    env = 'merlin-hml'
  } else {
    env = 'merlin-dev'
  }

  const config = {
    apiKey: user.dsFirebaseToken,
    authDomain: `gestcom-leroy-${env}.firebaseapp.com`,
    databaseURL: `https://gestcom-leroy-${env}.firebaseio.com`,
    projectId: `gestcom-leroy-${env}`,
    storageBucket: `gestcom-leroy-${env}.appspot.com`,
  }

  firebase.initializeApp(config)
}

export default firebase
